export enum Role {
  ALL = 'ALL',
  ADMIN = 'ADMIN',
  DOCTOR = 'DOCTOR',
  COMPANY_ADMIN = 'PHARMA_COMPANY',
  MSL = 'MSL',
  SALES_REP = 'SALES_REP',
  PATIENT_ASSISTANCE = 'PATIENT_ASSISTANCE',
}
